<a
  *ngIf="!isSdfCardFlow"
  class="findLocation"
  color="primary"
  (click)="openDialog()"
  >{{ labels?.stellar?.location?.findLocation }}</a
><sup *ngIf="kind === 'withdraw' && displaySuperscript && country === 'USA'"
  >1</sup
>

<button
  [disabled]="!enableSelectLocationBtn"
  *ngIf="
    isSdfCardFlow &&
    kind === 'deposit' &&
    (isLocationSelected$ | async) === false
  "
  class="select-location-button"
  color="primary"
  (click)="openDialog()"
  [ngClass]="{ active: enableSelectLocationBtn }"
>
  <span
    class="select-location-label"
    [ngClass]="{ active: enableSelectLocationBtn }"
    >{{
      capSentence1Letter(labels.stellar.sdfcard.common?.selectLocation)
    }}</span
  >
</button>

<button
  *ngIf="isSdfCardFlow && kind === 'deposit' && (isLocationSelected$ | async)"
  class="change-location-button"
  color="primary"
  (click)="openDialog()"
>
  {{ labels.stellar.sdfcard.common?.changeLocation }}
</button>

<button
  class="lookupLocation"
  *ngIf="kind === 'withdraw' && isSdfCardFlow"
  (click)="openDialog()"
>
  <span class="location-label-text">{{
    capSentence1Letter(labels.stellar.sdfcard.landingPage?.lookupLocation)
  }}</span>
</button>
